import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustSignals = () => {
  const trustBadges = [
    {
      id: 1,
      icon: 'Shield',
      title: 'SSL Secured',
      description: '256-bit encryption'
    },
    {
      id: 2,
      icon: 'CheckCircle',
      title: 'GAAP Compliant',
      description: 'Accounting standards certified'
    },
    {
      id: 3,
      icon: 'Lock',
      title: 'Data Protected',
      description: 'Bank-level security'
    },
    {
      id: 4,
      icon: 'Award',
      title: 'SOC 2 Certified',
      description: 'Security & availability'
    }
  ];

  return (
    <div className="w-full max-w-4xl mx-auto">
      <div className="text-center mb-8">
        <h3 className="text-lg font-semibold text-foreground mb-2">
          Trusted by 50,000+ Businesses Worldwide
        </h3>
        <p className="text-sm text-muted-foreground">
          Your financial data is protected with enterprise-grade security
        </p>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
        {trustBadges?.map((badge) => (
          <div
            key={badge?.id}
            className="flex flex-col items-center text-center p-4 bg-card border border-border rounded-lg hover:shadow-professional transition-shadow"
          >
            <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mb-3">
              <Icon name={badge?.icon} size={24} className="text-primary" />
            </div>
            <h4 className="font-medium text-foreground text-sm mb-1">
              {badge?.title}
            </h4>
            <p className="text-xs text-muted-foreground">
              {badge?.description}
            </p>
          </div>
        ))}
      </div>
      {/* Additional Trust Information */}
      <div className="mt-8 p-4 bg-muted/30 rounded-lg border border-border">
        <div className="flex items-center justify-center space-x-6 text-xs text-muted-foreground">
          <div className="flex items-center space-x-2">
            <Icon name="Users" size={16} />
            <span>50,000+ Active Users</span>
          </div>
          <div className="flex items-center space-x-2">
            <Icon name="Globe" size={16} />
            <span>Available in 25+ Countries</span>
          </div>
          <div className="flex items-center space-x-2">
            <Icon name="Clock" size={16} />
            <span>99.9% Uptime Guarantee</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrustSignals;